export const MAIL_TEMPLATE = {
  FINISH: "SRF",
  REJECT: "SRR",
  APPROVE: "SRA",
};
